module.exports = __webpack_public_path__ + "7e6df0d447657c6fe0f1b602495d9f60.pdf";